// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"bce2622f","290":"a2f24e2d","483":"e25a5d74","716":"25c6480d","857":"8a5def3e","923":"f06eaeed"}[chunkId] + ".chunk.js";
};